const translations = {
  1: { en: 'january', ru: 'января' },
  2: { en: 'february', ru: 'февраля' },
  3: { en: 'march', ru: 'марта' },
  4: { en: 'april', ru: 'апреля' },
  5: { en: 'may', ru: 'мая' },
  6: { en: 'june', ru: 'июня' },
  7: { en: 'july', ru: 'июля' },
  8: { en: 'august', ru: 'августа' },
  9: { en: 'september', ru: 'сентября' },
  10: { en: 'october', ru: 'октября' },
  11: { en: 'november', ru: 'ноября' },
  12: { en: 'december', ru: 'декабря' },
};

export const getDate = (timestamp = '', lang = 'en') => {
  if (!timestamp) {
    return '';
  }

  const objectDate = new Date(timestamp * 1000);

  if (isNaN(objectDate)) {
    return '';
  }

  const day = objectDate.getDate();
  const month = translations[objectDate.getMonth() + 1][lang] || translations[objectDate.getMonth() + 1].en;
  const year = objectDate.getFullYear();

  return `${day} ${month} ${year}`;
};
